export default "__VITE_ASSET__C0NTj_B1__"